const products = {
  products: [
    {
      id: "suko-billing",
      title: "Suko Billing",
      tagline: "Facturación sin complicaciones",
      landing: true,
      status: "live",
      platforms: ["Web", "iOS", "Android"],
      color: "#D8ECEB",
      accentColor: "#2A9D8F",
      description: "Solución de facturación y gestión financiera diseñada para pymes y autónomos. Crea, envía y gestiona facturas de forma rápida y profesional.",
      longDescription: "Suko Billing es la herramienta de facturación pensada para que los autónomos y pequeñas empresas puedan gestionar su actividad económica sin fricciones. Desde la creación de presupuestos hasta el envío automático de facturas a clientes y gestores, todo en un único lugar.",
      list: [
        "Gestión de clientes",
        "Gestión de productos y servicios",
        "Creación y envío de presupuestos",
        "Creación y envío de facturas",
        "Listas de distribución de facturas"
      ],
      highlights: [
        { icon: "⚡", label: "Facturas en segundos", description: "Genera y envía facturas profesionales en menos de un minuto." },
        { icon: "📬", label: "Envío automático", description: "Distribuye facturas directamente a tus clientes y gestores." },
        { icon: "📊", label: "Control total", description: "Visualiza el estado de todos tus documentos en un panel claro." }
      ],
      closeMessage: "Ideal para empresas que buscan automatizar su facturación y gestión financiera. Permitimos mandar los documentos directamente a los clientes. Además pueden añadir el email de sus gestores para que reciban de forma automática las facturas que generen. Actualmente estamos trabajando en añadir la funcionalidad de Verifactu para enviar facturas electrónicas.",
      image: "",
      url: "https://billing.suko.space",
      tiers: [
        {
          id: "free",
          name: "Gratuito",
          price: { monthly: 0, yearly: 0, currency: "EUR" },
          description: "Empieza sin compromiso",
          highlighted: false,
          features: [
            { label: "Hasta 5 clientes", included: true },
            { label: "Hasta 10 facturas al mes", included: true },
            { label: "Presupuestos", included: false },
            { label: "Listas de distribución", included: false },
            { label: "Gestión de productos y servicios", included: false },
            { label: "Soporte prioritario", included: false },
            { label: "Acceso multi-usuario", included: false }
          ],
          cta: { label: "Empezar gratis", url: "https://billing.suko.space/register" }
        },
        {
          id: "pro",
          name: "Pro",
          price: { monthly: 9.99, yearly: 95.88, currency: "EUR" },
          description: "Para profesionales y autónomos",
          highlighted: true,
          badge: "Más popular",
          features: [
            { label: "Hasta 5 clientes", included: false },
            { label: "Hasta 10 facturas al mes", included: false },
            { label: "Presupuestos", included: true },
            { label: "Listas de distribución", included: true },
            { label: "Gestión de productos y servicios", included: true },
            { label: "Soporte prioritario", included: false },
            { label: "Acceso multi-usuario", included: false }
          ],
          featuresOverride: [
            { label: "Clientes ilimitados", included: true },
            { label: "Facturas ilimitadas", included: true },
            { label: "Presupuestos", included: true },
            { label: "Listas de distribución", included: true },
            { label: "Gestión de productos y servicios", included: true },
            { label: "Soporte prioritario", included: false },
            { label: "Acceso multi-usuario", included: false }
          ],
          cta: { label: "Empezar con Pro", url: "https://billing.suko.space/register?plan=pro" }
        },
        {
          id: "business",
          name: "Business",
          price: { monthly: 29.99, yearly: 299.88, currency: "EUR" },
          description: "Para equipos y empresas",
          highlighted: false,
          features: [
            { label: "Clientes ilimitados", included: true },
            { label: "Facturas ilimitadas", included: true },
            { label: "Presupuestos", included: true },
            { label: "Listas de distribución", included: true },
            { label: "Gestión de productos y servicios", included: true },
            { label: "Soporte prioritario", included: true },
            { label: "Acceso multi-usuario", included: true }
          ],
          cta: { label: "Contactar ventas", url: "https://suko.space/contact" }
        }
      ],
      allFeatures: [
        "Clientes ilimitados",
        "Facturas ilimitadas",
        "Presupuestos",
        "Listas de distribución",
        "Gestión de productos y servicios",
        "Soporte prioritario",
        "Acceso multi-usuario"
      ]
    },
    {
      id: "suko-bookings",
      title: "Suko Bookings",
      tagline: "Gestión de reservas inteligente",
      landing: true,
      status: "coming-soon",
      platforms: ["Web", "iOS", "Android"],
      color: "#C6AEF5",
      accentColor: "#7C3AED",
      description: "Solución de gestión de reservas y espacios diseñada para pymes y autónomos. Organiza tu agenda, tus recursos y a tu equipo desde un solo lugar.",
      longDescription: "Suko Bookings centraliza la gestión de reservas, personal, servicios y espacios para que tu negocio funcione sin fricciones. Desde la cita online hasta la coordinación interna, todo integrado en una sola plataforma.",
      list: [
        "Gestión de clientes",
        "Gestión de servicios",
        "Gestión de horarios",
        "Gestión de espacios",
        "Gestión de materiales",
        "Gestión de personal"
      ],
      highlights: [
        { icon: "📅", label: "Agenda inteligente", description: "Gestiona tu disponibilidad y la de tu equipo sin conflictos." },
        { icon: "🏢", label: "Espacios y recursos", description: "Asigna salas, equipos y materiales a cada reserva automáticamente." },
        { icon: "🔔", label: "Recordatorios automáticos", description: "Reduce las ausencias con notificaciones automáticas a tus clientes." }
      ],
      closeMessage: "Ideal para empresas que buscan automatizar su facturación y gestión financiera. Permitimos mandar los documentos directamente a los clientes.",
      image: "",
      url: "https://bookings.suko.space",
      tiers: [
        {
          id: "starter",
          name: "Starter",
          price: { monthly: 0, yearly: 0, currency: "EUR" },
          description: "Empieza a gestionar reservas",
          highlighted: false,
          features: [
            { label: "Hasta 50 reservas al mes", included: true },
            { label: "1 miembro de equipo", included: true },
            { label: "Gestión de servicios", included: true },
            { label: "Gestión de espacios", included: false },
            { label: "Recordatorios automáticos", included: false },
            { label: "Página de reserva personalizada", included: false },
            { label: "Integraciones externas", included: false }
          ],
          cta: { label: "Unirme a la lista de espera", url: "https://suko.space/contact" }
        },
        {
          id: "professional",
          name: "Professional",
          price: { monthly: 14.99, yearly: 143.88, currency: "EUR" },
          description: "Para negocios en crecimiento",
          highlighted: true,
          badge: "Más popular",
          features: [
            { label: "Reservas ilimitadas", included: true },
            { label: "Hasta 5 miembros de equipo", included: true },
            { label: "Gestión de servicios", included: true },
            { label: "Gestión de espacios", included: true },
            { label: "Recordatorios automáticos", included: true },
            { label: "Página de reserva personalizada", included: true },
            { label: "Integraciones externas", included: false }
          ],
          cta: { label: "Unirme a la lista de espera", url: "https://suko.space/contact" }
        },
        {
          id: "enterprise",
          name: "Enterprise",
          price: { monthly: 39.99, yearly: 383.88, currency: "EUR" },
          description: "Para equipos y múltiples sedes",
          highlighted: false,
          features: [
            { label: "Reservas ilimitadas", included: true },
            { label: "Equipo ilimitado", included: true },
            { label: "Gestión de servicios", included: true },
            { label: "Gestión de espacios", included: true },
            { label: "Recordatorios automáticos", included: true },
            { label: "Página de reserva personalizada", included: true },
            { label: "Integraciones externas", included: true }
          ],
          cta: { label: "Contactar ventas", url: "https://suko.space/contact" }
        }
      ],
      allFeatures: [
        "Reservas ilimitadas",
        "Miembros de equipo",
        "Gestión de servicios",
        "Gestión de espacios",
        "Recordatorios automáticos",
        "Página de reserva personalizada",
        "Integraciones externas"
      ]
    },
    {
      id: "suko-shopping",
      title: "Suko Shopping",
      tagline: "Compra inteligente, ahorra más",
      landing: true,
      status: "coming-soon",
      platforms: ["Web", "iOS", "Android"],
      color: "#E7F58E",
      accentColor: "#65A30D",
      description: "Herramienta para organizar y optimizar tus compras en el supermercado. Compara precios, gestiona listas y encuentra siempre la mejor opción.",
      longDescription: "Suko Shopping te ayuda a planificar tus compras del supermercado de forma inteligente. Crea listas compartidas, compara precios entre tiendas y sigue el historial de tus gastos para ahorrar más cada semana.",
      list: [
        "Gestión de listas de compras",
        "Comparación de precios",
        "Gestión de productos"
      ],
      highlights: [
        { icon: "🛒", label: "Listas colaborativas", description: "Crea y comparte listas con tu familia o pareja en tiempo real." },
        { icon: "💰", label: "Compara precios", description: "Encuentra el precio más bajo entre los supermercados de tu zona." },
        { icon: "📈", label: "Historial de gastos", description: "Visualiza cuánto gastas y detecta oportunidades de ahorro." }
      ],
      closeMessage: "Ideal para particulares que buscan organizar sus compras en supermercados con precios más baratos.",
      image: "",
      url: "https://shopping.suko.space",
      tiers: [
        {
          id: "free",
          name: "Gratuito",
          price: { monthly: 0, yearly: 0, currency: "EUR" },
          description: "Para uso personal básico",
          highlighted: false,
          features: [
            { label: "Hasta 3 listas activas", included: true },
            { label: "1 usuario por lista", included: true },
            { label: "Comparación de precios básica", included: true },
            { label: "Listas colaborativas", included: false },
            { label: "Historial de precios", included: false },
            { label: "Alertas de bajada de precio", included: false }
          ],
          cta: { label: "Unirme a la lista de espera", url: "https://suko.space/contact" }
        },
        {
          id: "plus",
          name: "Plus",
          price: { monthly: 4.99, yearly: 47.88, currency: "EUR" },
          description: "Para familias y hogares",
          highlighted: true,
          badge: "Más popular",
          features: [
            { label: "Listas ilimitadas", included: true },
            { label: "Hasta 5 usuarios por lista", included: true },
            { label: "Comparación de precios avanzada", included: true },
            { label: "Listas colaborativas", included: true },
            { label: "Historial de precios", included: true },
            { label: "Alertas de bajada de precio", included: false }
          ],
          cta: { label: "Unirme a la lista de espera", url: "https://suko.space/contact" }
        },
        {
          id: "premium",
          name: "Premium",
          price: { monthly: 9.99, yearly: 95.88, currency: "EUR" },
          description: "La experiencia completa",
          highlighted: false,
          features: [
            { label: "Listas ilimitadas", included: true },
            { label: "Usuarios ilimitados por lista", included: true },
            { label: "Comparación de precios avanzada", included: true },
            { label: "Listas colaborativas", included: true },
            { label: "Historial de precios", included: true },
            { label: "Alertas de bajada de precio", included: true }
          ],
          cta: { label: "Unirme a la lista de espera", url: "https://suko.space/contact" }
        }
      ],
      allFeatures: [
        "Listas activas",
        "Usuarios por lista",
        "Comparación de precios",
        "Listas colaborativas",
        "Historial de precios",
        "Alertas de bajada de precio"
      ]
    }
  ]
};

export default products;
